import { useSelector } from "react-redux";
import defaultQuest from "../../assets/images/quests/default.png";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useRef, useState } from "react";
import { useModals } from "@/shared/contexts";
import { ModalName } from "@/shared/components";
import { ProductType } from "@/shared/components/modals/more-details-modal/MoreDetailsModal";
import { Button }from "@shared/components/button"

import defStyles from "./Quest.module.scss";
import nomadStyles from "./Quest.nomad.module.scss";
import { CoinIcon, PmPointIcon } from "@/shared/icons";

const styles =
  process.env.REACT_APP_BRAND === "nomad" ? nomadStyles : defStyles;
const Quest = ({ quest }) => {
  const { t } = useTranslation("main");

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const descriptionRef = useRef(null);

  const [isExpanded, setIsExpanded] = useState(false);

  const isRockets = process.env.REACT_APP_BRAND === "rockets";

  const formatRewardName = (rewardName) => {
    if (!rewardName) return "";

    let cleanName = rewardName
      .replace(/\s*PM\s+балл(ов|ы)\s*/gi, "")
      .replace(/\s*балл(ов|ы)\s+PM\s+PASS\s*/gi, "")
      .replace(/\s*PM\s+PASS\s*/gi, "")
      .replace(/\s*балл(ов|ы)\s*/gi, "");

    cleanName = cleanName.trim();

    return cleanName;
  };

  const wordCount = quest.description
    .split(/\s+/)
    .filter((word) => word).length;

  const modals = useModals();

  const handleLoginClick = () => {
    modals.openModal(ModalName.LOGIN);
  };

  const handleMoreDetailsClick = () => {
    modals.openModal(ModalName.MORE_DETAILS, {
      product: quest,
      onLoginClick: handleLoginClick,
      buttonText: t("begin"),
      closeable: true,
      productType: ProductType.QUEST,
      isAuthenticated: isAuthenticated,
      price: formatRewardName(quest.rewards[0].name),
    });
  };

  return (
    <div className={styles.container}>
      <div
        className={styles.imgWrapper}
        style={{
          backgroundImage: `url(${quest.image ? quest.image : defaultQuest})`,
        }}
      />

      <div className={styles.chestTitleWrapper}>
        <div className={styles.chestTitle}>
          <div className={styles.chestName}>
            <div className={styles.chestName_left}>
              <div>
                {quest.rewards[0] && formatRewardName(quest.rewards[0].name)}
              </div>
              <div className={styles.chest_icon}>
                {isRockets ? <CoinIcon /> : <PmPointIcon />}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.productName}>{quest.name}</div>

      <div className={styles.questTaskWrapper}>
        <div
          className={styles.questTask}
          ref={descriptionRef}
          style={{
            maxHeight: isExpanded ? "none" : "45px",
            overflow: isExpanded ? "visible" : "hidden",
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: quest.description }} />
        </div>
      </div>

      <div className={`${styles.productButtons} ${isRockets && styles.productButtons_rocketsGap}`}>
        {wordCount > 6 && (
          <button
            className={styles.readMoreBtn}
            onClick={handleMoreDetailsClick}
          >
            {t("readMoreBtn")}
          </button>
        )}
        {isAuthenticated ? (
          <div className={styles.btn}>
            <NavLink
              to={`${quest.url ? quest.url : "https://parimatch.kz/ru/gamification/daily-quests"}`}
              target="_blank"
              className={styles.btn}
            >
              <Button rounded={isRockets ? true : false}>{t("begin")}</Button>
            </NavLink>
          </div>
        ) : (
          <div onClick={handleLoginClick} className={styles.btn}>
            <Button rounded={isRockets ? true : false}>{t("begin")}</Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Quest;
